import { render, staticRenderFns } from "./solicitud-actualizacion-elegible.vue?vue&type=template&id=7506eac8&"
import script from "./solicitud-actualizacion-elegible.vue?vue&type=script&lang=ts&"
export * from "./solicitud-actualizacion-elegible.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports